// Footer.js
import React from 'react';
import whats from '../assets/icons/small_icons/WHATSAPP.png';
import liftpass from '../assets/icons/small_icons/LIFT_PASS_ICON.png';
import { Link } from 'react-router-dom';

const FooterLanding = ({show_wa=true}) => {
  return (
    <footer
      style={{
        backgroundColor: '#ffffff',
        color: '#000000',
        textAlign: 'center',
        padding: '0',
        width: '100%',
        position: 'relative',
        bottom: 0,
      }}
    >
      {/* SOS ROW */}
      {/* <a
        href="https://wa.me/525656859418"  // <-- Replace with your real number
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact via WhatsApp"
        style={{ textDecoration: 'none' }}
      >
        <div className="row p-0 m-0 w-100">
          <div
            className="col d-flex justify-content-center align-items-center m-0 p-0"
            style={{ backgroundColor: "#dd0c0c", cursor: "pointer" }}
          >
            <div className="d-flex align-items-center my-2">
              <p className="text-white mb-0 me-2">SOS</p>
              <img src={whats} alt="WhatsApp" style={{ width: "20px" }} />
            </div>
          </div>
        </div>
      </a> */}


      {/* WhatsApp Row */}
      {show_wa && (
      <a
        href="https://wa.me/525656859418"  // <-- Replace with your real number
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact via WhatsApp"
        style={{ textDecoration: 'none' }}
      >
        <div className="row p-0 m-0 w-100">
          <div
            className="col d-flex justify-content-center align-items-center m-0 p-0"
            style={{ backgroundColor: "#6acb5f", cursor: "pointer" }}
          >
            <div className="d-flex align-items-center my-2">
              <p className="text-white mb-0 me-2">Ayuda WhatsApp</p>
              <img src={whats} alt="WhatsApp" style={{ width: "20px" }} />
            </div>
          </div>
        </div>
      </a>
      )}



      {/* Lift Pass Row */}
      <Link to="/liftPass" aria-label="Go to lift pass page">
      <div className="row p-0 m-0 w-100">
        <div
          className="col d-flex justify-content-center align-items-center m-0 p-0"
          style={{ backgroundColor: "#007fff" }}
        >
          <div className="d-flex align-items-center my-2">
            <p className="text-white mb-0 me-2">Lift Pass</p>
            <img src={liftpass} alt="Lift Pass" style={{ width: "20px" }} />
          </div>
        </div>
      </div>
      </ Link>

      <div className="row p-0 m-0 w-100">
        <div
          className="col d-flex justify-content-center align-items-center m-0 p-0"
          style={{ backgroundColor: "#01153a" }}
        >
          <div className="d-flex align-items-center my-2">
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterLanding;
